//Service types
export const serviceTypes = {
  ACCOMMODATION: 'ACCO',
  ACTIVITY: 'ACTV',
  CAR: 'CAR',
  FLIGHT: 'FLTS',
  RESTAURANT: 'REST',
  TRAIN: 'TRN',
  TRANSFER: 'TRAN'
};

//Service type fields
export const serviceTypeFields = [
  {
    code: 'ACCO',
    name: 'Accommodation',
    servicetypefield: [
      {
        row: 1,
        colsize: 12,
        col: 1,
        title: 'Title',
        key: 'TITLE'
      },
      {
        row: 2,
        colsize: 12,
        col: 1,
        title: 'Description',
        key: 'DESCRIPTION'
      },
      {
        row: 3,
        colsize: 6,
        col: 1,
        title: 'Hotel',
        key: 'HOTELNAME'
      },
      {
        row: 3,
        colsize: 6,
        col: 7,
        title: 'Phone',
        key: 'PHONENUMBER'
      },
      {
        row: 4,
        colsize: 12,
        col: 1,
        title: 'Address',
        key: 'ADDRESS'
      },
      {
        row: 5,
        colsize: 4,
        col: 1,
        title: 'Check in Date',
        key: 'CHECKINDATE',
        isenabled: false
      },
      {
        row: 5,
        colsize: 4,
        col: 5,
        title: 'Check out Date',
        key: 'CHECKOUTDATE',
        isenabled: false
      },
      {
        row: 5,
        colsize: 4,
        col: 9,
        title: '# of Nights',
        key: 'NUMBEROFNIGHTS',
        description: 'Set # of Nights',
        isrequired: true
      },
      {
        row: 6,
        colsize: 12,
        col: 1,
        title: 'Room',
        key: 'ROOMTYPE'
      },
      {
        row: 7,
        colsize: 6,
        col: 1,
        title: 'Confirmation',
        key: 'CONFIRMATIONINFORMATION'
      },
      {
        row: 7,
        colsize: 6,
        col: 7,
        title: 'Link',
        key: 'LINK'
      },
      {
        row: 8,
        colsize: 12,
        col: 1,
        title: 'Meals Included',
        key: 'MEALSINCLUDED'
      },
      {
        row: 9,
        colsize: 12,
        col: 1,
        title: 'Add Image',
        key: 'UPLOADIMAGES'
      },
      {
        row: 10,
        colsize: 12,
        col: 1,
        title: 'Add Attachment',
        key: 'UPLOADATTACHMENTS'
      },
      {
        row: 11,
        colsize: 12,
        col: 1,
        title: 'Internal Notes',
        key: 'INTERNALNOTE'
      }
    ]
  },
  {
    code: 'TRAN',
    name: 'Transfer',
    servicetypefield: [
      {
        row: 1,
        colsize: 12,
        col: 1,
        title: 'Title',
        key: 'TITLE'
      },
      {
        row: 2,
        colsize: 12,
        col: 1,
        title: 'Description',
        key: 'DESCRIPTION'
      },
      {
        row: 3,
        colsize: 6,
        col: 1,
        title: 'Company Name',
        key: 'COMPANYNAME'
      },
      {
        row: 3,
        colsize: 6,
        col: 7,
        title: 'Driver Name',
        key: 'DRIVERNAME'
      },
      {
        row: 4,
        colsize: 12,
        col: 1,
        title: 'Phone',
        key: 'PHONENUMBER'
      },
      {
        row: 5,
        colsize: 6,
        col: 1,
        title: 'Pick Up Time',
        key: 'PICKUPTIME'
      },
      {
        row: 5,
        colsize: 6,
        col: 7,
        title: 'Drop Off Time',
        key: 'DROPOFFTIME'
      },

      {
        row: 6,
        colsize: 6,
        col: 1,
        title: 'Pick Up Address',
        key: 'PICKUPADDRESS'
      },
      {
        row: 6,
        colsize: 6,
        col: 7,
        title: 'Drop Off Address',
        key: 'DROPOFFADDRESS'
      },

      {
        row: 7,
        colsize: 12,
        col: 1,
        title: 'Confirmation',
        key: 'CONFIRMATIONINFORMATION'
      },
      {
        row: 8,
        colsize: 12,
        col: 1,
        title: 'Add Image',
        key: 'UPLOADIMAGES'
      },
      {
        row: 9,
        colsize: 12,
        col: 1,
        title: 'Add Attachment',
        key: 'UPLOADATTACHMENTS'
      },
      {
        row: 10,
        colsize: 12,
        col: 1,
        title: 'Internal Notes',
        key: 'INTERNALNOTE'
      }
    ]
  },
  {
    code: 'ACTV',
    name: 'Activity',
    servicetypefield: [
      {
        row: 1,
        colsize: 12,
        col: 1,
        title: 'Title',
        key: 'TITLE'
      },
      {
        row: 2,
        colsize: 12,
        col: 1,
        title: 'Description',
        key: 'DESCRIPTION'
      },
      {
        row: 3,
        colsize: 6,
        col: 1,
        title: 'Provider Name',
        key: 'PROVIDERNAME'
      },
      {
        row: 3,
        colsize: 6,
        col: 7,
        title: 'Phone',
        key: 'PHONENUMBER'
      },
      {
        row: 4,
        colsize: 12,
        col: 1,
        title: 'Address',
        key: 'ADDRESS'
      },
      {
        row: 5,
        colsize: 6,
        col: 1,
        title: 'Start Time',
        key: 'STARTTIME'
      },
      {
        row: 5,
        colsize: 6,
        col: 7,
        title: 'Duration',
        key: 'DURATION'
      },
      {
        row: 6,
        colsize: 6,
        col: 1,
        title: 'Confirmation',
        key: 'CONFIRMATIONINFORMATION'
      },
      {
        row: 6,
        colsize: 6,
        col: 7,
        title: 'Link',
        key: 'LINK'
      },
      {
        row: 7,
        colsize: 12,
        col: 1,
        title: 'Meals Included',
        key: 'MEALSINCLUDED'
      },
      {
        row: 8,
        colsize: 12,
        col: 1,
        title: 'Add Image',
        key: 'UPLOADIMAGES'
      },
      {
        row: 9,
        colsize: 12,
        col: 1,
        title: 'Add Attachment',
        key: 'UPLOADATTACHMENTS'
      },
      {
        row: 10,
        colsize: 12,
        col: 1,
        title: 'Internal Notes',
        key: 'INTERNALNOTE'
      }
    ]
  },
  {
    code: 'FLTS',
    name: 'Flight',
    servicetypefield: [
      {
        row: 1,
        colsize: 12,
        col: 1,
        title: 'Title',
        key: 'TITLE'
      },
      {
        row: 2,
        colsize: 12,
        col: 1,
        title: 'Description',
        key: 'DESCRIPTION'
      },
      {
        row: 3,
        colsize: 6,
        col: 1,
        title: 'Airline',
        key: 'AIRLINE'
      },
      {
        row: 3,
        colsize: 6,
        col: 7,
        title: 'Flight Number',
        key: 'FLIGHTNUMBER'
      },
      {
        row: 4,
        colsize: 6,
        col: 1,
        title: 'Departure Time',
        key: 'DEPARTURETIME'
      },
      {
        row: 4,
        colsize: 6,
        col: 7,
        title: 'Arrival Time',
        key: 'ARRIVALTIME'
      },

      {
        row: 5,
        colsize: 6,
        col: 1,
        title: 'Departure Airport',
        key: 'DEPARTUREAIRPORT'
      },
      {
        row: 5,
        colsize: 6,
        col: 7,
        title: 'Arrival Airport',
        key: 'ARRIVALAIRPORT'
      },
      {
        row: 6,
        colsize: 12,
        col: 1,
        title: 'Confirmation',
        key: 'CONFIRMATIONINFORMATION'
      },
      {
        row: 7,
        colsize: 12,
        col: 1,
        title: 'Add Image',
        key: 'UPLOADIMAGES'
      },
      {
        row: 8,
        colsize: 12,
        col: 1,
        title: 'Add Attachment',
        key: 'UPLOADATTACHMENTS'
      },
      {
        row: 9,
        colsize: 12,
        col: 1,
        title: 'Internal Notes',
        key: 'INTERNALNOTE'
      }
    ]
  },
  {
    code: 'REST',
    name: 'Restaurant',
    servicetypefield: [
      {
        row: 1,
        colsize: 12,
        col: 1,
        title: 'Title',
        key: 'TITLE'
      },
      {
        row: 2,
        colsize: 12,
        col: 1,
        title: 'Description',
        key: 'DESCRIPTION'
      },
      {
        row: 3,
        colsize: 6,
        col: 1,
        title: 'Restaurant',
        key: 'RESTAURANTNAME'
      },
      {
        row: 3,
        colsize: 6,
        col: 7,
        title: 'Phone',
        key: 'PHONENUMBER'
      },
      {
        row: 4,
        colsize: 12,
        col: 1,
        title: 'Address',
        key: 'ADDRESS'
      },
      {
        row: 5,
        colsize: 6,
        col: 1,
        title: 'Confirmation',
        key: 'CONFIRMATIONINFORMATION'
      },
      {
        row: 5,
        colsize: 6,
        col: 7,
        title: 'Link',
        key: 'LINK'
      },
      {
        row: 6,
        colsize: 12,
        col: 1,
        title: 'Add Image',
        key: 'UPLOADIMAGES'
      },
      {
        row: 7,
        colsize: 12,
        col: 1,
        title: 'Add Attachment',
        key: 'UPLOADATTACHMENTS'
      },
      {
        row: 8,
        colsize: 12,
        col: 1,
        title: 'Internal Notes',
        key: 'INTERNALNOTE'
      }
    ]
  },
  {
    code: 'CAR',
    name: 'Car',
    servicetypefield: [
      {
        row: 1,
        colsize: 12,
        col: 1,
        title: 'Title',
        key: 'TITLE'
      },
      {
        row: 2,
        colsize: 12,
        col: 1,
        title: 'Description',
        key: 'DESCRIPTION'
      },
      {
        row: 3,
        colsize: 6,
        col: 1,
        title: 'Rental Company',
        key: 'RENTALCOMPANY'
      },
      {
        row: 3,
        colsize: 6,
        col: 7,
        title: 'Car Class',
        key: 'CARCLASS'
      },
      {
        row: 5,
        colsize: 6,
        col: 1,
        title: 'Pick Up Date',
        key: 'PICKUPDATE'
      },
      {
        row: 5,
        colsize: 6,
        col: 7,
        title: 'Drop Off Date',
        key: 'DROPOFFDATE'
      },
      {
        row: 6,
        colsize: 6,
        col: 1,
        title: 'Pick Up Time',
        key: 'PICKUPTIME'
      },
      {
        row: 6,
        colsize: 6,
        col: 7,
        title: 'Drop Off Time',
        key: 'DROPOFFTIME'
      },
      {
        row: 7,
        colsize: 6,
        col: 1,
        title: 'Pick Up Address',
        key: 'PICKUPADDRESS'
      },
      {
        row: 7,
        colsize: 6,
        col: 7,
        title: 'Drop Off Address',
        key: 'DROPOFFADDRESS'
      },
      {
        row: 8,
        colsize: 12,
        col: 1,
        title: 'Confirmation',
        key: 'CONFIRMATIONINFORMATION'
      },
      {
        row: 9,
        colsize: 12,
        col: 1,
        title: 'Add Image',
        key: 'UPLOADIMAGES'
      },
      {
        row: 10,
        colsize: 12,
        col: 1,
        title: 'Add Attachment',
        key: 'UPLOADATTACHMENTS'
      },
      {
        row: 11,
        colsize: 12,
        col: 1,
        title: 'Internal Notes',
        key: 'INTERNALNOTE'
      }
    ]
  },
  {
    code: 'TRN',
    name: 'Train',
    servicetypefield: [
      {
        row: 1,
        colsize: 12,
        col: 1,
        title: 'Title',
        key: 'TITLE'
      },
      {
        row: 2,
        colsize: 12,
        col: 1,
        title: 'Description',
        key: 'DESCRIPTION'
      },
      {
        row: 3,
        colsize: 6,
        col: 1,
        title: 'Train Company',
        key: 'TRAINCOMPANY'
      },
      {
        row: 3,
        colsize: 6,
        col: 7,
        title: 'Train Number',
        key: 'TRAINNUMBER'
      },
      {
        row: 4,
        colsize: 6,
        col: 1,
        title: 'Departure Date',
        key: 'DEPARTUREDATE'
      },
      {
        row: 4,
        colsize: 6,
        col: 7,
        title: 'Arrival Date',
        key: 'ARRIVALDATE'
      },
      {
        row: 5,
        colsize: 6,
        col: 1,
        title: 'Departure Time',
        key: 'DEPARTURETIME'
      },
      {
        row: 5,
        colsize: 6,
        col: 7,
        title: 'Arrival Time',
        key: 'ARRIVALTIME'
      },

      {
        row: 6,
        colsize: 6,
        col: 1,
        title: 'Departure Station',
        key: 'DEPARTUREADDRESS'
      },
      {
        row: 6,
        colsize: 6,
        col: 7,
        title: 'Arrival Station',
        key: 'ARRIVALADDRESS'
      },
      {
        row: 7,
        colsize: 12,
        col: 1,
        title: 'Confirmation',
        key: 'CONFIRMATIONINFORMATION'
      },
      {
        row: 8,
        colsize: 12,
        col: 1,
        title: 'Add Image',
        key: 'UPLOADIMAGES'
      },
      {
        row: 9,
        colsize: 12,
        col: 1,
        title: 'Add Attachment',
        key: 'UPLOADATTACHMENTS'
      },
      {
        row: 10,
        colsize: 12,
        col: 1,
        title: 'Internal Notes',
        key: 'INTERNALNOTE'
      }
    ]
  }
];
